<template>
  <div>
    <el-dialog
      top="5vh"
      v-loading="loading"
      title="房间状态"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose">
      <div style="height: 70vh;">
        <el-button @click="$emit('roomstatuAll')">确定</el-button>
        <div style="margin-top: 20px;overflow-y: auto;height: 60vh;">
          <el-table ref="multipleTable" border :data="data" height="60vh" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="sort" label="序号" width="120"></el-table-column>
              <el-table-column prop="label" label="收费项目" width="280"></el-table-column>
            </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
      data () {
        return {
          loading:false,
          dialogVisible:false,
          data: [],
          multipleSelection:[],
          defaultProps: {
            children: 'children',
            label: 'label'
          }
        }
      },
      mounted(){

      },
      //事件
      methods: {
        //返回数据
        getInvo(data){
          // console.log(data)
          this.dialogVisible = true;
          if(this.data.length < 1){
            this.selects(data);
          }
        },
        // 查询
        selects(data){
          this.$myhttp.post('admin/common/roomstatus',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.data = backdata.data.data;
          },err=>{
            this.$Message.error('请求异常!');
          });
        },
        handleSelectionChange(val) {
          this.multipleSelection = val;
        },
        getReturn(){
          this.dialogVisible = false;
          return this.multipleSelection;
        },
        handleClose(done) {
          done();
        },
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Forms/common/RoomStatus.vue